import isEmpty from '../IsEmpty';
import { ticketLinkSelections } from '../../constants';
import { ticketLinkTypes } from '../../constants/ticketLinkTypes';
import {
  PROMO_VISIBLE_START_DATE,
  PROMO_VISIBLE_END_DATE,
} from '../../../common/components/RelativeDateAndTime/constants';
import { formatReceiveOfferPromoVisibilityDates } from '../ReceiveAndFormatDates';
/**
 * Builds offer promotion data to match UI fields
 * @param {object} offer data
 * @param {string} location of user (template or event)
 * @returns Object
 */
export const receiveOfferPromotion = (offer, location, flag) => {
  if (!offer.axsPromotion || isEmpty(offer.axsPromotion)) return null;

  const p = offer.axsPromotion;
  const axsPromotion = { ticketLinkType: p.ticketLinkType };
  if (Number(p.ticketLinkType) === Number(ticketLinkTypes.SEPARATE_PROMOTION)) {
    axsPromotion.promotionId = p.promotionId;
    axsPromotion.modifiedUTC = p.modifiedUTC;
    axsPromotion.promoName = p.promotionName;
    axsPromotion.promoShortDescription = p.promotionShortDescription;
    axsPromotion.promoDescription = p.promotionDescription;
    axsPromotion.promoGroup = p.groupId;
    axsPromotion.promoTemplate = p.templateId;
    axsPromotion.promotionId = p.promotionId;
    axsPromotion.status = p.status;
    axsPromotion.display = p.displayListArray[0];
    axsPromotion.visibleStartDate = p.visibleStartDate;
    axsPromotion.visibleEndDate = p.visibleEndDate;
    axsPromotion.dates = formatReceiveOfferPromoVisibilityDates(p, flag);
    if (location === 'offer') axsPromotion.contentStatus = p.publishStatus;
  }
  return axsPromotion;
};

export const formatOfferCMSData = (offer, isOnSalePromo, isSeparatePromo) => {
  const promoData = {};
  const offerPromotion = offer && offer.axsPromotion;
  if (
    isOnSalePromo &&
    offerPromotion &&
    typeof offerPromotion.ticketLinkType === 'number'
  ) {
    promoData.ticketLink = ticketLinkSelections.filter(
      (sel) => Number(sel.id) === Number(offerPromotion.ticketLinkType)
    )[0];
    return promoData;
  } else if (isSeparatePromo && offerPromotion) {
    promoData.ticketLink = ticketLinkSelections.filter(
      (sel) => Number(sel.id) === Number(offerPromotion.ticketLinkType)
    )[0];
    promoData.promoName = offerPromotion.promoName;
    promoData.description = offerPromotion.description;
    promoData.promoDescription = offerPromotion.promoDescription;
    promoData.promoShortDescription = offerPromotion.promoShortDescription;
    promoData.promotionId = offerPromotion.promotionId;
    promoData.modifiedUTC = offerPromotion.modifiedUTC;
    promoData.dates = {
      visibleStartDate:
        offerPromotion.dates && offerPromotion.dates.visibleStartDate
          ? offerPromotion.dates.visibleStartDate
          : { date: '', fieldId: PROMO_VISIBLE_START_DATE },
      visibleEndDate:
        offerPromotion.dates && offerPromotion.dates.visibleEndDate
          ? offerPromotion.dates.visibleEndDate
          : { date: '', fieldId: PROMO_VISIBLE_END_DATE },
    };
    if (typeof offerPromotion.contentStatus === 'number') {
      promoData.contentStatus =
        offerPromotion.contentStatus === 1 ? 'Published' : 'Unpublished';
    } else {
      promoData.contentStatus = offerPromotion.contentStatus;
    }
    if (typeof offerPromotion.display === 'number') {
      promoData.display = offerPromotion.display === 1 ? 'Private' : 'EDP';
    } else {
      promoData.display = offerPromotion.display;
    }
    promoData.status = offerPromotion.status;
    return Object.assign({}, promoData, {
      promoGroup: offerPromotion.promoGroup,
      promoTemplate: offerPromotion.promoTemplate,
    });
  }
};



// WEBPACK FOOTER //
// ./src/common/lib/OfferPromotion/offerPromotion.js